export default __webpack_public_path__ + "static/media/tailored_armed_groups_strategies.6d3aa6a0.jpg";